/**
 * Notification Service
 * API client for notification operations
 */

import api from './api';
import type { NotificationListResponse, UnreadCountResponse } from '../types/notification';

export const notificationService = {
  /**
   * Get notifications for current user
   */
  async getNotifications(params?: {
    page?: number;
    limit?: number;
    unreadOnly?: boolean;
  }): Promise<NotificationListResponse> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.set('page', params.page.toString());
    if (params?.limit) queryParams.set('limit', params.limit.toString());
    if (params?.unreadOnly) queryParams.set('unreadOnly', 'true');

    const { data } = await api.get(`/notifications?${queryParams.toString()}`);
    return data;
  },

  /**
   * Get unread notification count
   */
  async getUnreadCount(): Promise<UnreadCountResponse> {
    const { data } = await api.get('/notifications/unread-count');
    return data;
  },

  /**
   * Mark a notification as read
   */
  async markAsRead(notificationId: string): Promise<void> {
    await api.patch(`/notifications/${notificationId}/read`);
  },

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<{ count: number }> {
    const { data } = await api.patch('/notifications/mark-all-read');
    return data;
  },

  /**
   * Delete a notification
   */
  async deleteNotification(notificationId: string): Promise<void> {
    await api.delete(`/notifications/${notificationId}`);
  },
};
